export enum JourneyStageEnum
{
    Identificacao = 1,
    MedirPressao = 2,
    MedirPeso = 3,
    Resultado = 4,
}